import React, { SyntheticEvent } from 'react';

import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

import { Box, Container, Tab, Tabs } from '@mui/material';

import useAppNavigation from '~/hooks/useAppNavigation';

import PageHeader from '../Common/Elements/PageHeader';

import { tripPlannerChatTabs } from './tripPlannerChatTabs';

export default function TripPlannerChatPage() {
  const { push } = useAppNavigation();
  const location = useLocation();

  const currentTab = tripPlannerChatTabs.find((tab) => tab.path === location.pathname) ?? tripPlannerChatTabs[0];
  const tripsTabPath = tripPlannerChatTabs[0]?.path ?? '';

  const handleTabChange = (_event: SyntheticEvent, newValue: string) => {
    push({
      pathname: newValue,
      search: newValue === tripsTabPath ? location.search : '',
    });
  };
  const CurrentTabComponent = currentTab.component;

  return (
    <Container maxWidth="lg">
      <Helmet>
        <title>TripPlanner - Chat - {currentTab.title}</title>
      </Helmet>

      <PageHeader title={`TripPlanner - Chat - ${currentTab.title}`} />

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={currentTab.path} onChange={handleTabChange}>
          {tripPlannerChatTabs.map((tab) => (
            <Tab key={tab.path} value={tab.path} label={tab.title} />
          ))}
        </Tabs>
      </Box>

      <CurrentTabComponent />
    </Container>
  );
}
